import { ReactNode } from "react";
import { Link } from "react-router";

type FixaLinkProps = {
  to: string;
  state?: any;
  children: ReactNode;
  className?: string | undefined;
  "data-testid"?: string | undefined;
  "aria-label"?: string | undefined;
};

function FixaLink(props: FixaLinkProps) {
  return <Link {...props} />;
}

export default FixaLink;
